module.exports = __webpack_public_path__ + "img/f3-2-l.2042be3b.png";